import React, { useState } from 'react'
import styles from '@/src/components/scss/Schedule.module.scss'
import { Box, useMediaQuery } from '@mui/material'
import { Typography, Button } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Calendar from '@/src/components/Schedule/Calendar/Calendar'
import Timeslots from '@/components/Schedule/Calendar/Timeslots'
import InfoDialog from '@/components/Schedule/InfoDialog'
import AlertDialog from '@/components/Schedule/AlertDialog'
import { useSchedule } from '@/components/Schedule/ScheduleRoot'
import { useBackend } from '@/src/providers/BackendProvider'

const TimeSelection = () => {
  const usePC = useMediaQuery(theme.breakpoints.up('md'))
  const {
    date,
    setDate,
    time,
    params,
    reschedule,
    viewId,
    setViewId,
    history,
    setErrorOpen
  } = useSchedule()
  const { refreshAppointment } = useBackend()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)
  const [calendarCollapse, setCalendarCollapse] = useState(date.date !== null)

  function handleDateSelect(selection) {
    setDate(selection)
    if (!usePC) {
      setCalendarCollapse(true)
    }
  }
  async function handleClick() {
    if (
      Object.values(date).some((e) => e === null) ||
      Object.values(time).some((e) => e === -1)
    ) {
      setAlertOpen(true)
      return
    }
    const token = params.token
      ? params.token
      : JSON.parse(window.sessionStorage.getItem('schedule-token'))
    const id = params.id
      ? params.id
      : JSON.parse(window.sessionStorage.getItem('appointment-id'))
    if (id) {
      const res = await reschedule(token, id)
      if (res.status < 300) {
        history.push(viewId)
        await refreshAppointment()
        setViewId(viewId + 1)
        return res
      } else {
        setErrorOpen(true)
        return res
      }
    } else {
      setDialogOpen(true)
    }
  }

  return (
    <>
      <Box className={styles.viewRoot}>
        <Box className={styles.selection}>
          <Box className={styles.calendar}>
            <Typography variant="subh1" sx={{ mb: '16px', fontWeight: 600 }}>
              Select Date
            </Typography>
            <Calendar
              setSelection={setDate}
              selection={date}
              onSelect={handleDateSelect}
              collapse={!usePC && calendarCollapse}
              setCollapse={setCalendarCollapse}
            />
          </Box>
          <Box className={styles.timeslots}>
            <Typography variant="subh1" sx={{ mb: '16px', fontWeight: 600 }}>
              Select Time
            </Typography>
            <Timeslots />
          </Box>
        </Box>
        <Button
          size="large"
          style={{ marginTop: '32px' }}
          handleClick={handleClick}
          loadable
        >
          continue
        </Button>
      </Box>
      <InfoDialog open={dialogOpen} setOpen={setDialogOpen} />
      <AlertDialog open={alertOpen} setOpen={setAlertOpen} />
    </>
  )
}

export default TimeSelection
